<template>
  <div>
    <BreadcrumbBanner
      :pageTitle="$t('New Games')"
      :links="[
        { name: $t('Home'), url: '/' },
        { name: $t('New Games') }
      ]"
    />

    <!--Search Provider-->
    <!-- <div class="search-provider pt-60 mb-4">
      <div class="container-fluid">
        <div class="search-provider-wrapper">
          <div class="left-select-bar src-provider d-flex align-items-center">
            <div class="step-two">
              <select name="select-one" id="select1">
                <option value="1">Providers</option>
                <option value="1">Combo</option>
                <option value="1">Champion</option>
              </select>
              <span class="seven-icon"
                ><img src="@/assets/img/play/seven.svg" alt="play-img"
              /></span>
            </div>
          </div>
          <div class="right-search">
            <form action="#">
              <input type="text" placeholder="Search..." />
              <div class="search">
                <i class="fas fa-magnifying-glass"></i>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div> -->
    <!--Search Provider-->

    <!--Casino Demo-->
    <div class="casino-demo pb-60 pb-60 mt-4">
      <div class="container-fluid">
        <div class="all-games-wrapper">
          <div class="row g-3">
            <div v-for="game in games" :key="game.id" class="col-xxl-3 col-xl-4 col-md-4 col-sm-6">
              <GameCard :game="game" />
            </div>
          </div>
        </div>
      </div>
      <div class="more-btn text-center bt" v-if="nextPage != null">
        <a href="javascript:;" class="border-btn" @click="loadMore">
          <span>{{ $t("Load more") }}</span>
        </a>
      </div>
    </div>
    <!--Casino Demo-->

  </div>
</template>

<script>
import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { useNewGamesStore } from "@/store/newGames";
import { mapState, mapActions } from "pinia";
import GameCard from "@/components/partials/GameCard.vue";

export default {
  name: "NewGamesPage",
  components: {
    BreadcrumbBanner,
    GameCard,
  },
  computed: {
    ...mapState(useNewGamesStore, ["games", "nextPage"]),
  },
  methods: {
    ...mapActions(useNewGamesStore, ["loadLatestGames"]),
    async loadMore() {
      await this.loadLatestGames();
    },
  },
  async mounted() {
    this.nextPage = 1;
    await this.loadLatestGames();
  },
};
</script>
